import { Alert, AlertTitle, Box } from '@mui/material';

/**
 * GLX-1922, acceptance criterion 1: Galaxy warns that a large team will trigger a
 * realm creation.
 *
 * Deliberately has no buttons and no state, matching CreateSandboxWarning - the
 * acknowledge and cancel affordances come from SimpleModal's shared footer. Its
 * only job is to make the wait and the fire-and-forget outcome explicit before
 * anything is created.
 *
 * `severity="info"` rather than `error`: unlike the sandbox notice, nothing here
 * is destructive or disruptive to other tenants. It is a "this takes a while and
 * then finishes on its own" notice.
 */
export const CreateTeamDedicatedRealmWarning = () => {
  return (
    <Box>
      <Alert severity="info">
        <AlertTitle>A new dedicated realm will be created</AlertTitle>
        This team is large enough to get its own realm, so submitting will{' '}
        <strong>create a new dedicated realm first, which takes about 5-10 minutes.</strong> The
        team is then created automatically once the realm is ready.
        <br />
        <br />
        You do not need to wait or keep this tab open - the realm and the team will appear in the
        Realms and Teams tables when it finishes.
      </Alert>
    </Box>
  );
};
